import { Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-team-equipment-info',
  standalone: true,
  templateUrl: './skeleton-team-equipment-info.component.html',
  imports: [],
})
export class SkeletonTeamEquipmentInfoComponent {}
